export default [
  {
    list:[
      {
        no: '01 - 1',
        title:'The electrical room',
        explain:[
          {
            title:'Dual substations',
            body: 'Dual power feeds from the main circuit and the backup circuit to provision against emergencies like unpredicted power-cut.',
          },
          {
            title:'A double distributor',
            body: 'Using nighttime electricity to freeze water to cool the server during the daytime to reduce electrical load.',
          }
        ],
        img: '/img/dc/chuncheon/ft-1-1-1.jpg',
      },
      {
        no: '01 - 2',
        title:'UPS Room',
        explain:[
          {
            title:'UPS to prepare for the blackouts',
            body: 'UPS (Uninterruptible Power Supply) allows an uninterrupted electricity supply even in case of a power outage. It also regulates current frequency, voltage, and wave shapes.',
          },
          {
            title:'Dynamic UPS stores energy',
            body: 'Dynamic UPS stores kinetic energy by rotating the induction coupling at the speed of 3,600rpm normally and convert stored kinetic energy into electricity in case of a power outage',
          }
        ],
        img: '/img/dc/chuncheon/ft-1-1-2.jpg',
      },
      {
        no: '01 - 3',
        title:'Current Transformers',
        explain:[
          {
            title:'Special electric wire for the data center - Bus Duct',
            body: 'Bus duct is specially made electric wire for the datacenter that uses high voltage and current',
          },
          {
            title:'The minimized electricity conversion process',
            body: 'We have minimized electricity conversion processes from the substation to IT equipment in the data center to reduce power loss.',
          }
        ],
        img: '/img/dc/chuncheon/ft-1-1-3.jpg',
      },
      {
        no: '01 - 4',
        title:'STS room',
        explain:[
          {
            title:'Dual power feeds',
            body: 'STS is back-up equipment for power supply in case of a power outage caused by UPS error. STS and electrical panels are also double redundancy to guarantee continuous power supply to the servers.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-1-4.jpg',
      },
      {
        no: '01 - 5',
        title:'An eco-friendly way to cool servers',
        explain:[
          {
            title:'AMU',
            body: 'AMU(Air Misting Unit) is a special cooling system designed by Naver which filters the air and uses a mist to lower the temperature of air for cooling. In Spring and Autumn, AMU solely cool servers. In Winter, cold air from outside mixed with warm air inside to meet the right temperature and humidity.',
          },
          {
            title:'NAMU I & II ',
            body: 'NAMU(NAVER Air Membrane I & II) Unit  lowers the temperature through evaporation as wind is pushed through cold, flowing water. NAMU II developed version of NAMU I reduced internal resistance and enhanced efficiency. NAMU II showed the efficiency improvement effect by 30~40% compared to NAMU I. NAMU II was installed at the southern wing in 2017 and proved its operational efficiency.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-2-1.jpg',
      },
      {
        no: '01 - 6',
        title: 'Proprietary server racks',
        explain: [
          {
            body: 'NAVER developed special racks for space efficiency. Proprietary server racks can place a maximum of 44 servers in a single area. The height is 2.4 m(51Unit), about 40 cm taller than average racks.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-3-1.jpg',
      },
      {
        no: '01 - 7',
        title: 'Proprietary high power racks',
        explain: [
          {
            body: 'The high power racks developed by NAVER provides an almost double electricity capacity of 11kW, 50A per rack compared to 6.6. kW, 30A electricity capacity of average power racks. NAVER ’s high power racks are much more stable for the server that requires high power. (Compatible with 19”/21”)',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-3-2.jpg',
      },
      {
        no: '01 - 8',
        title: 'Automation systems',
        explain: [
          {
            body: 'The Building Automation System (BAS) is at the core of datacenter \'Gak\'s sequential control capability. The cooling system automatically activated if the temperature of the server room raises. Facility Monitoring System (FMS) monitors temperature and electric current conditions to prevent any service errors. The data collected by BAS is analyzed and managed by the Building Energy Management System (BEMS) in real-time.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-4-1.jpg',
      },
      {
        no: '01 - 9',
        title: 'Adoption of Datacenter <br class="hidden-xxl-up">Aisle Containment System ',
        explain: [
          {
            body: 'Datacenter Gak adopted the Datacenter Aisle Containment System (DACS-Data center Aisle Containment System) to separate cold air with hot air. The cooling efficiency has improved much as DACS lowered the temperature of the cold aisle by 2 ℃ and the hot aisle by 3 ℃.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-4-2.jpg',
      }
    ]
  },
  {
    list: [
      {
        no: '02 - 1',
        title: 'Automated OS Installments',
        body: 'NAVER developed a system for automation of the OS installments to minimize the huge resources required for the vast scale server management. Automated Linux Installation System (ALIS) saves 30% of the operating time compared to the previous way.',
        name: 'ALIS <br/>(Automated Linux Installation System)',
        img: '/img/dc/chuncheon/ft-2-1.jpg',
        bg: '/img/dc/chuncheon/ft-2-1-p.jpg',
      },
      {
        no: '02 - 2',
        title: 'Remote fault management system',
        body: 'NAVER developed Auto-Discovery Out of Band (ADOOB) to resolve any issues anytime anywhere. It allows the operator to remotely check the system for any server error and resolve the issue in real-time.',
        name: 'ADOOB <br/>(Auto Discovery Out of Band)',
        img: '/img/dc/chuncheon/ft-2-2.jpg',
        bg: '/img/dc/chuncheon/ft-2-2-p.jpg',
      },
      {
        no: '02 - 3',
        title: 'Datacenter fabric',
        body: 'Datacenter Gak has adopted data center fabric to internal network structure for a fast response to the traffic without any delays. Fabric is a backbone system of the server, internet, load balancer and the interconnections between them. ',
        img: '/img/dc/chuncheon/ft-2-3.jpg',
        bg: '/img/dc/chuncheon/ft-2-3-p.jpg',
      },
      {
        no: '02 - 4',
        title: 'AMIGO & Bong9',
        body: 'AMIGO is a proprietary security system of Naver that detects a site with malicious codes. Bong 9 prevents malicious code spreading URL in advance, block it after analysis and monitors. These security systems enable fast responding to the attack on the internet and system error caused by on/offline infrastructural malfunction.',
        img: '/img/dc/chuncheon/ft-2-4.jpg',
        bg: '/img/dc/chuncheon/ft-2-4-p.jpg',
      },
      {
        no: '02 - 5',
        title: 'Standardized real-time fault handling',
        body: 'Proprietary TTS tools respond fast to any service disruption anytime, anywhere. The system faults are handled in five steps according to the disruption level with consideration for users.',
        name: 'TTS <br/>(Trouble Ticket System)',
        img: '/img/dc/chuncheon/ft-2-5.jpg',
        bg: '/img/dc/chuncheon/ft-2-5-p.jpg',
      },
    ]
  },
  {
    list: [
      {
        no: '03 - 1',
        title: 'Intrusion <br>detection & prevention',
        body: 'A DDOS(Distributed Denial of Service) attack is one of the biggest threats to IT companies as their core business is a web-based service. Naver monitors the system for 24 hours and immediately organize a task force team in case of the intrusion detection. Also, we continually enhance the security system based on accumulated intrusion attempt information.',
        img: '/img/dc/chuncheon/ft-3-1.en.svg',
        imgM: '/img/dc/chuncheon/ft-3-1-m.en.svg',
      },
      {
        no: '03 - 2',
        title: 'Data dualization <br>to prevent data loss',
        body: 'Data (service) dualization creating a preparatory server on a network to prepare for any malfunction. If you save a text at Naver blogs, it will automatically be saved to five different spots within the data center the next day. Dualized servers also replicate the data in other data centers to prevent any service interruptions.',
        img: '/img/dc/chuncheon/ft-3-2.en.svg',
        imgM: '/img/dc/chuncheon/ft-3-2-m.en.svg',
      },
    ]
  }
];
